const PREFIX = "jhonks.cache.";
const MAX_ENTRY_CHARS = 400000;

export function readCache(key) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || !("data" in parsed)) return null;
    return parsed.data;
  } catch (error) {
    return null;
  }
}

export function writeCache(key, data) {
  try {
    const payload = JSON.stringify({ savedAt: Date.now(), data });
    if (payload.length > MAX_ENTRY_CHARS || payload.includes("data:image")) return;
    localStorage.setItem(PREFIX + key, payload);
  } catch (error) {
    // Storage can be full or blocked. The network response is still shown.
  }
}
